import React from 'react';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { languagePath, SITE_URL } from '../../seo/routes';

export default function parseBlogContent(content, language) {
  // Older translations use self-closing tags instead of closing formatting tags.
  const repaired = content.replace(/<(h[1-6]|b)\s*\/>/g, '</$1>');
  const options = {
    replace(node) {
      if (node.name !== 'a' || !node.attribs?.href) return undefined;
      let url;
      try { url = new URL(node.attribs.href, SITE_URL); } catch { return undefined; }
      if (url.origin !== SITE_URL) return undefined;
      const href = languagePath(url.pathname + url.search + url.hash, language);
      return <a {...attributesToProps(node.attribs)} href={href}>{domToReact(node.children, options)}</a>;
    },
  };
  return parse(repaired, options);
}
